import React from 'react';
import './MaintenanceBar.css';

const MaintenanceBar = () => {
  return (
    <div className="maintenance-bar">
      <div className="maintenance-content">
        <div className="maintenance-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            <path d="M9 12l2 2 4-4"/>
          </svg>
        </div>
        <div className="maintenance-text">
          <span className="maintenance-message">
            We are currently upgrading our platform and performing maintenance. Some features may be temporarily unavailable.
          </span>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceBar;